<template>
    <div>
        <template v-for="child in steps_item_children">
            <step v-if="child.id && !child.not_visible" :key="child.id"
                :step_name="child.title" :id="child.id" :is_ready="child.is_ready" :level=level
                :class="active_step == child.id ? 'active' : ''"
                :data="child"
                v-on:set_active_step="() => $emit('set_active_step', child)"
            />
            <child_steps v-if="child.children && !(child.not_visible || child.not_visible_children)" :key="child.id + '_children'"
                :steps_item_children="child.children" :level="level + 1"
                :active_step="active_step"
                v-on:set_active_step="(step) => $emit('set_active_step', step)" />
        </template>
    </div>
</template>

<script>
import step from "./step"

export default {
    name : "child_steps",
    props :
    {
        steps_item_children : Array,
        level : Number,
        active_step : String,
    },

    components :
    {
        step,
    },
}
</script>